export const routes = {
  // main routes
  homePage: "/",
  directionsPage: "/napravleniya",
  tariffsPage: "/tarify",
  marketPage: "/market",
  helpPage: "/tekhnicheskaya_podderzhka_sbis_support",

  // directions routes
  reportPage: "/elektronnaya-otchetnost-sbis-onlain",
  accountingPage: "/bukhgalteriya_i_uchet_sbis",
  crmPage: "/crm_dlia_aktivnykh_prodazh",
  edoPage: "/edo_elektronniy_dokumentooborot_sbis",
  kaEdoPage: "/edo-s-kontragentami",
  ediPage: "/zakazy_i_postavki_edi_elektronnyy_obmen_dannymi",
  controlBusinessProccessesPage: "/upravlieniie_bizniesprotsiessami",
  internationalEdoPage: "/mezhdunarodnyj-edo",
  eplPage: "/Electronnie-pytevie-listi",
  eTrNPage: "/ETrN-i-perevosochnie-dokumenti",
  ofdPage:"/podklyucheniye_kassy_k_ofd_sbis_kak_podklyuchitsya",
  automationBusinessPage:"/automation-bisness",
  marketAndOnlineSalePage:"/avtomatizatsiya_roznitsy_magazinov_i_aptek_sbis",
  restaurantCafeBistroPage:"/avtomatizatsiya_obshchepita_sbis",
  salonAndServiceSectorPage:"/sbis_avtomatizatsiya_raboty_salonov_sfery_uslug",
  tradeAndProductionPage:"/torgovla-i-proizvodstvo",
  mobileStaffPage:"/sbis_mobilnyye_sotrudniki_kuryery",
  videoControlPage:"/videonablyudeniye_sklad_kukhnya_vkhod_ofis_kassa_torgovyy_zal",
  exchangeWithGovPage:"/obiazatielnaia_markirovka_tovarov",
  cloudTelephonyPage:"/oblachnaya_telefoniya_ats_v_oblake",
  aboutCompaniesPage:"/vsio_o_kompaniiakh",
  tendersAndPurchasesPage:"/torghovlia_zakupki_i_skladskoi_uchiet",
  personalControlPage:"/ypravlenie-personalom",
  personalEDOPage:"/kadrovi-edo",
  salaryAndPersonnelPage:"/zarplati-i-kadri",
  militaryRegistrationPage:"/voinskii-ychet",
  controlWorkingTime:"/sbis_uchiet_i_kontrol_rabochiegho_vriemieni",
  recruitmentOfPersonnelPage:"/podbor-personala",
  kpiAndMotivationPage:"/kpi-i-motivacia",
  corporatePortalPage:"/sbis_korporativnaya_sotsialnaya_set_sotsset",
  messengerPage:"/messenger",
  webinarsAndCommunicationsPage:"/sbis_video_svyaz_soveshchaniya_konferentsii_organizatsiya",
  remoteControlPage:"/ydalennii-dostyp",

  // ecp routes
  ecpPage: "/uс_fns_elektronnaya_podpis_ecp",
  mchdPage: "/mashinochitaemye-doverennosti",
  corpUcPage: "/kuc_korporativnyj_udostoveryayushchij_centr",
  logisticsPage: "/transport-i-logistika",

  chatUsPage: "/chat",
  cookiePolicy: "/cookie-policy"
}